export type FileType = "planning_summary";
export type FileTypeSettings = {
  id: string;
  label: string;
};

export const fileTypes: Record<FileType, FileTypeSettings> = {
  planning_summary: { id: "planning_summary", label: "Planning summary" },
};

export const EDITOR_FILE_EXTENSION = "landtech";
